const securityQuestionCodes = [
    {code: "favBookMovie", questionText: "What is your favorite book or movie?"},
    {code: "fictChar", questionText: "Who is your favorite fictional character?"},
    {code: "vidGame", questionText: "What’s your favorite video game?"},
    {code: "vacation", questionText: "What is your dream vacation destination?"},
    {code: "cartChar", questionText: "What is your favorite cartoon character?"},
    {code: "ughFood", questionText: "What is your least favorite food?"},
    {code: "superPower", questionText: "If you had a superpower, what would it be?"},
    {code: "petDragon", questionText: "What name would you give a pet dragon?"},
    {code: "rockBand", questionText: "What would be the name of your rock band?"},
    {code: "favClass", questionText: "What’s your favorite class subject?"}
]
export default securityQuestionCodes;